export default __webpack_public_path__ + "static/media/villa_4.d7a1e5a4.jpg";